import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { Plan } from "../../Graphql/types/plan";

export interface PlanState {
  planList: Plan[];
  planDetail: Plan | null;
}

export const initialPlanState: PlanState = {
  planList: [],
  planDetail: null,
};

export const planSlice = createSlice({
  name: "plans",
  initialState: initialPlanState,
  reducers: {
    setPlanList: (state, action: PayloadAction<Plan[]>) => {
      state.planList = action.payload;
    },
    resetPlanList: (state) => {
      state.planList = initialPlanState.planList;
    },
    setPlanDetail: (state, action: PayloadAction<Plan | null>) => {
      state.planDetail = action.payload;
    },
    resetPlanDetail: (state) => {
      state.planDetail = initialPlanState.planDetail;
    },
  },
});

export const { setPlanList, resetPlanList, setPlanDetail, resetPlanDetail } =
  planSlice.actions;

export default planSlice.reducer;
